module.exports = __webpack_public_path__ + "img/folder.ffaa1da7.svg";